(() => {
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const slides = [...root.querySelectorAll('[data-slide]')];
    const thumbs = [...root.querySelectorAll('[data-thumb]')];
    const dialog = root.querySelector('[data-lightbox]');
    let current = 0;
    const select = (index) => {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== current; });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === current)));
      const thumb = thumbs[current];
      if (thumb) {
        const strip = thumb.parentElement;
        strip.scrollTo({left: Math.max(0, thumb.offsetLeft - strip.offsetLeft - strip.clientWidth / 2 + thumb.clientWidth / 2), behavior: 'auto'});
      }
    };
    root.querySelector('[data-prev]')?.addEventListener('click', () => select(current - 1));
    root.querySelector('[data-next]')?.addEventListener('click', () => select(current + 1));
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => select(i)));
    root.querySelector('.sx-pet__gallery')?.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        select(current + (event.key === 'ArrowRight' ? 1 : -1));
        thumbs[current]?.focus({preventScroll:true});
      }
    });
    slides.forEach(slide => slide.addEventListener('click', () => {
      const image = slide.querySelector('img')?.cloneNode(true);
      if (!image || !dialog) return;
      image.removeAttribute('loading');
      dialog.querySelector('[data-lightbox-image]').replaceChildren(image);
      dialog.showModal();
    }));
    dialog?.querySelector('[data-close]').addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', event => {
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    });
    root.querySelector('[data-share]')?.addEventListener('click', async () => {
      const status = root.querySelector('[data-share-status]');
      try {
        await navigator.clipboard.writeText(root.dataset.url);
        status.textContent = status.dataset.copied;
      } catch {
        status.textContent = status.dataset.failed + ': ' + root.dataset.url;
      }
    });
  }
  document.querySelectorAll('[data-sx-pet]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-sx-pet]').forEach(initialize));
})();

